<template>
  <FullPageModal
    :is-open="useRemoteControlStore().isRCModalOpen"
    @close-modal="useRemoteControlStore().closeRCModal">
    <RemoteControlInactiveReason
      v-if="!useRemoteControlStore().isRemotelyControllable"
      :rcInactiveReason="useRemoteControlStore().reasonForNoRemoteControl" />
    <RemoteControlStepper v-else-if="useUserConfigStore().canRemotelyControlDevices && useUserConfigStore().isRCSetupComplete.includes(false)" />
    <RemoteControlForm v-else />
  </FullPageModal>
</template>

<script setup lang="ts">
import FullPageModal from "@/components/library/FullPageModal/FullPageModal.vue";
import RemoteControlStepper from "../RemoteControlSetup/RemoteControlStepper.vue";
import RemoteControlForm from "./RemoteControlForm.vue";
import RemoteControlInactiveReason from "./RemoteControlInactiveReason.vue";
import { useRemoteControlStore } from "@/storeModules/remoteControl/remoteControlStore";
import { useUserConfigStore } from "@/storeModules/userConfigs";
</script>
